module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp3_8003.4699f0b1.png";